module.exports = __webpack_public_path__ + "media/images/touch/homescreen144-c40495ba64bbd93423b46c98f84ef75c.png";